app.lazyloadController = app.lazyloadController || {};

app.lazyloadController.indexAction = {
    
    /**
     * Initialisation de la fonction
     * @returns {undefined}
     */
    init : function () {
        $('.lazy').lazyLoadXT();
    }

};